import React, { Component } from 'react'
import styled from 'styled-components'

import { isRunningAsElectronApp } from '../../lib/environmentUtils'

const Anchor = styled.div`
  cursor: ${props => props.url ? 'pointer' : 'default'};
`

class Link extends Component {
  openURL = () => {
    if (this.props.url) {
      if (isRunningAsElectronApp()) {
        window.require('electron').shell.openExternal(this.props.url)
      } else {
        window.open(this.props.url)
      }
    }
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        onClick: this.openURL
      })
    )
    return (
      <Anchor {...this.props} onClick={this.openUrl}>
        {childrenWithProps}
      </Anchor>
    )
  }
}

export default Link



// WEBPACK FOOTER //
// ./src/components/shared/link.js